<template>
  <b-card class="custom-card gutter-b" no-body v-if="challenge">
    <b-card-body>
      <div class="d-flex justify-content-between mb-3">
        <h4 class="font-weight-bolder">Week challenge</h4>
        <profiles-points :points="challenge.points"></profiles-points>
      </div>

      <router-link to="/paths/">
        <h3>{{ challenge.title }}</h3>
      </router-link>
      <div v-html="challenge.description"></div>
      <div class="delivered">
        <div v-if="checkChallenge(challenge) != 0">
          <div class="d-flex justify-content-between">
            <div>
          <p class="badge badge-success  m-0">Delivered!!</p>
          <p
            class="badge badge-info ml-5 py-4 px-7 m-0"
            v-if="
              findProof(me, challenge).isValid &&
                findProof(me, challenge).isChecked
            "
          >
            Valid Challenge!
          </p>
          <p
            class="badge badge-danger ml-5 py-4 px-7 m-0"
            v-else-if="
              !findProof(me, challenge).isValid &&
                findProof(me, challenge).isChecked
            "
          >
            Not Valid Challenge!
          </p>
          <p
            class="badge badge-secondary ml-5  m-0"
            v-else
          >
            Pending for validation...
          </p>
          </div>
          
          </div>
          <div class="comments">
            <CommentsChallenge
              :proof="findProof(me, challenge)"
              v-if="findProof(me, challenge)"
            ></CommentsChallenge>
          </div>
        </div>
      </div>
      <div v-if="extended">
        <div class="col-12 delivery" v-if="challenge.proof.toDeliver">
          <h6>To deliver:</h6>
          <div v-html="challenge.proof.toDeliver"></div>
          <div v-if="checkChallenge(challenge)==0" > <!-- || !checkChallenge(challenge).isChecked"-->
            <div class="" v-if="challenge.proof">
              <div class="url my-5" v-if="challenge.proof.url">
                <b-form-group description="Please, use full Google Drive URL">
                  <b-form-input
                    v-model="urlToUpload"
                    placeholder="Enter the url of this project"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="upload" v-if="challenge.proof.images > 0">
                <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="true"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/*,.zip'"
                  :maxSize="'10MB'"
                  :maxFiles="challenge.proof.images"
                  :helpText="'Choose images'"
                  :errorText="{
                    type: 'Invalid file type. Only images Allowed',
                    size: 'Files should not exceed 10MB in size'
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="fileRecords"
                ></VueFileAgent>
              </div>
              <div class="d-flex justify-content-between">
                <div v-if="challenge.proof.images > 0">
                  <b-badge variant="secondary" class="mt-4">
                    Uploading
                    {{ fileRecordsForUpload.length }} files
                  </b-badge>
                </div>

                <span
                  class="btn bg-success mt-5 text-white"
                  @click="uploadFiles(challenge)"
                >
                  Send challenge
                </span>
                 <!-- <span
                  class="btn bg-success mt-5 text-white"
                  @click="uploadFiles(challenge)"
                >
                  Modify challenge
                </span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
import ProfilesPoints from "./ProfilesPoints.vue";
import CommentsChallenge from "../extras/comments-challenge.vue";
export default {
  components: { ProfilesPoints, CommentsChallenge },
  name: "ChallengePath",

  props: {
    path: { type: Object, required: true },
    extended: { type: Boolean }
  },
  data() {
    return {
      // user: [],
      levelUserName: "",
      levelUser: 0,
      // levels: {},
      team: [],
      puntsequip: 10,
      disseny: 20,
      development: 30,
      urlToUpload:"",// this.challengeIn ? this.challengeIn.proof.url : ""
      fileRecords: [],//this.challengeIn ? this.challengeIn.proof.images : [],
      uploadUrl: process.env.VUE_APP_API_URL_UPLOADS + "upload",
      uploadHeaders: { "X-Test-Header": "vue-file-agent" },
      fileRecordsForUpload: [] // maintain an upload queue
    };
  },
  computed: {
    profiles() {
      return this.$store.getters.getProfiles;
    },
    challenge() {
      console.log(this.path);
      return this.$store.getters.getChallenges.find(
        c => c.path == this.path._id
      );
    },
    me() {
      return this.$store.getters.getMyUser;
    },
    // challengeIn(){
    //   return this.challenge.participants.find(u => u.user === this.me._id)||null;
    // }
  },
  methods: {
    bgColor(i) {
      let color = i.split("1)");

      return color[0] + "0.3)";
    },
    checkPoints(profile) {
      let punts = this.user.points.profiles.find(p => p.profile == profile);
      return punts ? punts.points : 0;
    },
    findProof(me, challenge) {
      return challenge.participants.find(u => u.user === this.me._id);
    },
    checkChallenge(challenge) {
      console.log(
        "check",
        challenge.participants.filter(u => u.user === this.me._id)
      );
      return challenge.participants.filter(u => u.user === this.me._id);
    },
    uploadFiles: async function(challenge) {
      console.log(challenge, this.urlToUpload, this.fileRecordsForUpload);
      let proof = {
        proof: { url: null, images: [], comments: [] },
        user: this.me._id
      };
      if (challenge.proof.images > 0) {
        this.uploadHeaders.folder = "challenges/" + challenge._id + "/";
        console.log(this.uploadHeaders.folder);
        // Using the default uploader. You may use another uploader instead.
        console.log(this.$refs.vueFileAgent);
        if (Array.isArray(this.$refs.vueFileAgent)) {
          await this.$refs.vueFileAgent[0].upload(
            this.uploadUrl,
            this.uploadHeaders,
            this.fileRecordsForUpload
          );
        } else {
          await this.$refs.vueFileAgent.upload(
            this.uploadUrl,
            this.uploadHeaders,
            this.fileRecordsForUpload
          );
        }
        proof.proof.images = [];
        this.fileRecords.forEach(f => {
          console.log(f);
          proof.proof.images.push(f.upload.data.file.path);
        });
      }
      if (challenge.proof.url) {
        proof.proof.url = this.urlToUpload;
      }
      console.log("challenge", challenge);
      //challenge.participants.push(proof);
      axios
        .put("challenges/" + challenge._id, { $push: { participants: proof } })
        .then(response => {
          console.log(response);
          this.$store.dispatch("fetchChallenges");
          if (response.status == 200) {
            Swal.fire({
              title: "Update challenge",
              text: "",
              icon: "success"
            });
          }
        });
      this.fileRecordsForUpload = [];
      this.urlToUpload = "";
    },
    deleteUploadedFile: function(fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        fileRecord => !fileRecord.error
      );
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      );
    },
    onBeforeDelete: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function(fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
    deleteVersion(i) {
      i.proof.pop();
      axios.put("instances/" + i._id, i).then(() => {
        this.$store.dispatch("fetchMyInstances");
      });
    }
  }
};
</script>
<style lang="scss">
.d-grid {
  display: grid;
}
.sessions {
  .d-grid {
    &.grid-sessions {
      grid-template-columns: repeat(1, 100px 30px 30px 1fr 250px 50px);
    }
  }
}
.myUser {
  .grid-profile {
    grid-template-columns: repeat(1, 1fr 3fr);
    .info {
    }
  }
}
</style>
